class ProductItemCarousel extends HTMLElement {
  connectedCallback() {
    this.imagesEl.addEventListener('scroll', this.handleImagesScroll.bind(this), {passive: true});
  }

  handleImagesScroll(event) {
    const imagesEl = event?.target;
    const selectedIndex = (imagesEl?.scrollLeft <= (imagesEl?.offsetWidth / 2)) ? 0 : 1;

    this.imageControlEls.forEach((imageControlEl, index) => {
      imageControlEl.setAttribute('aria-selected', (Number(index) === selectedIndex));
    });
  }

  get imagesEl() {
    return this.querySelector('[data-product-item-carousel-el="images"]');
  }

  get imageControlEls() {
    return this.querySelectorAll('[data-product-item-carousel-el="image-control"]');
  }
}

customElements.define('product-item-carousel', ProductItemCarousel);
